/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@mui/utils");
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * * Escape hatch for broken dependencies not supporting SSR.
 * * Improve the time-to-first paint on the client by only rendering above the fold.
 * * Reduce the rendering time on the server.
 * * Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://v6.mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://v6.mui.com/material-ui/api/no-ssr/)
 */ function NoSsr(props) {
    const { children, defer = false, fallback = null } = props;
    const [mountedState, setMountedState] = React.useState(false);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!defer) {
            setMountedState(true);
        }
    }, [
        defer
    ]);
    React.useEffect(()=>{
        if (defer) {
            setMountedState(true);
        }
    }, [
        defer
    ]);
    // TODO casting won't be needed at one point https://github.com/DefinitelyTyped/DefinitelyTyped/pull/65135
    return mountedState ? children : fallback;
}
"production" !== "production" ? NoSsr.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * You can wrap a node.
   */ children: _propTypes.default.node,
    /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   * @default false
   */ defer: _propTypes.default.bool,
    /**
   * The fallback content to display.
   * @default null
   */ fallback: _propTypes.default.node
} : void 0;
if ("production" !== 'production') {
    // eslint-disable-next-line
    NoSsr['propTypes' + ''] = (0, _utils.exactProp)(NoSsr.propTypes);
}
var _default = exports.default = NoSsr;
